import { Route } from "react-router-dom";
import SalesDashboardPage from "@/pages/SalesDashboardPage";
import SalesCustomersPage from "@/pages/SalesCustomersPage";
import SalesDocsPage from "@/pages/SalesDocsPage";
import SalesInvoicesPage from "@/pages/SalesInvoicesPage";
import SalesRepsPage from "@/pages/SalesRepsPage";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { FeatureGate } from "@/components/layout/FeatureGate";
import { MANAGER_ROLES } from "@/utils/role";

const SALES_ROLES = [...MANAGER_ROLES, "sales_rep"];

const PAGES = [
  { path: "/sales", element: <SalesDashboardPage /> },
  { path: "/sales/customers", element: <SalesCustomersPage /> },
  { path: "/sales/quotations", element: <SalesDocsPage docType="quotation" /> },
  { path: "/sales/orders", element: <SalesDocsPage docType="order" /> },
  { path: "/sales/deliveries", element: <SalesDocsPage docType="delivery" /> },
  { path: "/sales/invoices", element: <SalesInvoicesPage /> },
  { path: "/sales/reps", element: <SalesRepsPage /> },
];

// مسارات المبيعات: محمية بالدور ومغلقة بمفتاح ميزة `sales` الذي يفتحه مالك المنصة.
export const salesRoutes = PAGES.map(({ path, element }) => (
  <Route
    key={path}
    path={path}
    element={
      <ProtectedRoute roles={SALES_ROLES}>
        <FeatureGate feature="sales">{element}</FeatureGate>
      </ProtectedRoute>
    }
  />
));
